module.exports = __webpack_public_path__ + "static/media/png.b35d4fe9.svg";